import { NotificationProgrammatic as Notification } from 'buefy'

export default {
    install(Vue, options) {

        // Define your functions
        const error = (message) => {
            Notification.open({
                duration: 3000,
                message: message ? message : 'something happened',
                position: 'is-bottom-right',
                type: 'is-danger',
            })
        }

        const success = (message) => {
            Notification.open({
                duration: 3000,
                message: message ? message : 'something happened',
                position: 'is-top-right',
                type: 'is-primary',
            })
        }



        // Instance method
        Vue.prototype.$notifier = { 
            error, 
            success 
        };
    }
};


